import { getPPIDLoggedInStatus } from '@sch-inventory/advertory/features/tracker';

import { getPulseActor } from '../pulse';
import { getUserIdAsync } from '../paywall/spid';
import { getAssetProvider } from '../../utils/player/player';

import { GetAdnSettings } from './types';
import { PpidWrapper } from './ppid/PpidWrapper';

let ppidWrapper: PpidWrapper | null = null;

export const withPPID =
  (getSettings: GetAdnSettings): GetAdnSettings =>
  async (context, options, stream, defaults, player) => {
    const provider = getAssetProvider(player);
    if (provider === 'brandstudio') {
      return null;
    }

    ppidWrapper = ppidWrapper || new PpidWrapper(player);

    const settings = await getSettings(
      context,
      options,
      stream,
      defaults,
      player
    );

    await ppidWrapper.ready;
    if (!ppidWrapper.tracker) {
      return settings || null;
    }

    // make sure pulse tracker has the user data already
    if (!ppidWrapper.tracker.builders.actor) {
      ppidWrapper.tracker.update({
        actor: getPulseActor(provider, getUserIdAsync),
      });
    }

    if (!settings) {
      return null;
    }

    const eids: string = await ppidWrapper.getEids();
    const ppidKeywords = getPPIDLoggedInStatus();
    settings.adSlots.params = {
      ...settings.adSlots.params,
      ...ppidKeywords,
      eids,
    };

    // PPID for display ads
    if (settings.adPlacements) {
      settings.adPlacements.params.keywords = {
        ...settings.adPlacements.params.keywords,
        ...ppidKeywords,
      };
    }

    return settings;
  };
